// After a deploy, a tab still running the previous build will request lazy
// chunks whose hashed filenames no longer exist. Reloading once picks up the
// new index.html and its new chunk names. (Same helper as the merchant app.)

const RELOAD_KEY = 'chunk-reload-at';
const RELOAD_WINDOW_MS = 10_000;

// Chrome/Edge, Firefox, Safari and webpack word this error differently.
const CHUNK_ERROR_PATTERN =
    /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError/i;

let reloadPending = false;

export const isChunkLoadError = (error) =>
    error?.name === 'ChunkLoadError' || CHUNK_ERROR_PATTERN.test(error?.message || String(error || ''));

// Returns true when a reload is (or already was) triggered. Returns false if we
// reloaded moments ago and still failed, so the error shows instead of looping.
export function reloadForStaleChunk() {
    if (reloadPending) return true;
    try {
        const last = Number(sessionStorage.getItem(RELOAD_KEY));
        if (last && Date.now() - last < RELOAD_WINDOW_MS) return false;
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
        return false;
    }
    reloadPending = true;
    window.location.reload();
    return true;
}
